export const onTabChange = (
  tab: string,
  setActiveTab: React.Dispatch<React.SetStateAction<string>>,
  activeAuthId?: (authId: string) => void,
) => {
  setActiveTab(tab);
  activeAuthId?.(tab);
};
